import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    /* New modern theme - dark mode with vibrant accents */
    --primary-color: #5C64F4;
    --primary-color-rgb: 92, 100, 244;
    --secondary-color: #49B5F8;
    --secondary-color-rgb: 73, 181, 248;
    --accent-color: #22EABA;
    --accent-color-rgb: 34, 234, 186;
    --text-color: #E8E9F3;
    --text-color-secondary: #B3B6D3;
    --background-color: #14151F;
    --background-color-rgb: 20, 21, 31;
    --card-background: #1E2030;
    --card-background-rgb: 30, 32, 48;
    --success-color: #22EABA;
    --warning-color: #FFB547;
    --danger-color: #FF5C72;
    --box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    --border-radius: 10px;
    --transition-speed: 0.3s;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    font-family: 'Roboto', 'Segoe UI', Arial, sans-serif;
    background-color: var(--background-color);
    background-image: 
      radial-gradient(circle at 10% 20%, rgba(92, 100, 244, 0.08) 0%, transparent 20%),
      radial-gradient(circle at 90% 50%, rgba(73, 181, 248, 0.06) 0%, transparent 25%),
      radial-gradient(circle at 40% 80%, rgba(34, 234, 186, 0.07) 0%, transparent 30%);
    color: var(--text-color);
    line-height: 1.6;
    min-height: 100vh;
    overflow-x: hidden;
  }

  body::-webkit-scrollbar {
    width: 10px;
  }

  body::-webkit-scrollbar-track {
    background-color: var(--background-color);
  }

  body::-webkit-scrollbar-thumb {
    background-color: var(--secondary-color);
    border-radius: 10px;
  }

  body::-webkit-scrollbar-thumb:hover {
    background-color: var(--accent-color);
  }

  h1, h2, h3, h4, h5, h6 {
    margin-bottom: 1rem;
    font-weight: 700;
    line-height: 1.2;
  }

  h1 {
    font-size: 2.5rem;
  }
  
  h2 {
    font-size: 2rem;
  }
  
  h3 {
    font-size: 1.75rem;
  }
  
  h4 {
    font-size: 1.5rem;
  }

  button {
    cursor: pointer;
    font-family: inherit;
    border: none;
    background-color: var(--secondary-color);
    color: var(--background-color);
    padding: 0.75rem 1.5rem;
    border-radius: var(--border-radius);
    font-size: 1rem;
    font-weight: 600;
    transition: all var(--transition-speed) ease-in-out;
    
    &:hover {
      background-color: var(--accent-color);
      transform: translateY(-2px);
      box-shadow: var(--box-shadow);
    }
    
    &:active {
      transform: translateY(0);
    }
    
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  a {
    color: var(--accent-color);
    text-decoration: none;
    transition: color var(--transition-speed) ease;
    
    &:hover {
      text-decoration: underline;
      color: var(--secondary-color);
    }
  }

  p {
    margin-bottom: 1rem;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 1rem;
  }

  .card {
    background-color: var(--card-background);
    border-radius: var(--border-radius);
    box-shadow: var(--box-shadow);
    padding: 1.5rem;
    margin-bottom: 1.5rem;
    transition: transform var(--transition-speed) ease-in-out;
    
    &:hover {
      transform: translateY(-5px);
    }
  }

  /* Utility classes */
  .text-center {
    text-align: center;
  }

  .text-right {
    text-align: right;
  }

  .text-accent {
    color: var(--accent-color);
  }

  .mt-1 { margin-top: 0.5rem; }
  .mt-2 { margin-top: 1rem; }
  .mt-3 { margin-top: 1.5rem; }
  .mt-4 { margin-top: 2rem; }

  .mb-1 { margin-bottom: 0.5rem; }
  .mb-2 { margin-bottom: 1rem; }
  .mb-3 { margin-bottom: 1.5rem; }
  .mb-4 { margin-bottom: 2rem; }

  /* Animation keyframes */
  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.05);
    }
    100% {
      transform: scale(1);
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  /* Selection color */
  ::selection {
    background-color: var(--accent-color);
    color: var(--background-color);
  }
`;

export default GlobalStyles; 